<template>
  <div
    class="home-banner"
    :style="{
      background: `${setting[currentIndex].background}`,
    }"
    @mouseenter.stop="hover = true"
    @mouseleave.stop="hover = false"
  >
    <div
      class="home-cover"
      :style="{
        backgroundImage: `url(${replaceHTTPResource(setting[currentIndex].source)})`,
      }"
    >
      <div class="home-text">
        <div class="home-text-logo" :style="{backgroundImage: `url(${replaceHTTPResource(setting[currentIndex].textLogo)})`}"></div>
        <div class="home-text-btn">
          <button @click="enterCompanyAdd" class="flex-center home-text-btn-1">
            <span>立即加入</span>
            <img
              :src="require(`@/assets/banners/banner_ic_btn_add.png`)"
              width="18px"
              height="auto"
              style="margin-left: 9px"
              alt="enter"
            />
          </button>
          <button @click="enterDoc" class="flex-center home-text-btn-2">
            <span>技术文档</span>
            <img
              :src="require(`@/assets/banners/banner_ic_btn_page.png`)"
              width="18px"
              height="auto"
              style="margin-left: 9px"
              alt="enter"
            />
          </button>
        </div>
      </div>
      <div class="home-handle">
        <div
          class="home-handle-circle"
          v-for="(item, index) in setting"
          :key="index"
          :class="{ 'home-handle-active': index === currentIndex }"
          @click="handleCarousel(index)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerImage1 from '@/assets/banners/img_banner01_new.png'
import BannerImage2 from '@/assets/banners/img_banner02_new.png'
// import BannerTextLogo1 from '@/assets/banners/img_banner_text02.png'
// import BannerTextLogo2 from '@/assets/banners/img_banner_text03.png'

export default {
  name: 'Banner',
  data() {
    return {
      setting: [
        {
          background: '#0a1e3c',
          source: BannerImage1,
          // textLogo: BannerTextLogo1
          textLogo: ''
        },
        {
          background: '#0a1e3c',
          source: BannerImage2,
          // textLogo: BannerTextLogo2
          textLogo: ''
        },
      ],
      currentIndex: 0,
      carousel: null,
      hover: false
    }
  },
  mounted() {
    this.carousel = setInterval(() => {
      if (this.hover) return
      this.currentIndex = this.currentIndex ? 0 : 1
    }, 5000)
  },
  beforeDestroy() {
    clearInterval(this.carousel)
  },

  methods: {
    enterCompanyAdd() {
      this.$LogReport.sendCustomEvent('openplat_quickin_click')
      if (this.$store.state.userInfo && !this.$store.state.companyInfo) {
        this.$bus.$emit('showCompanyDialog', true)
      } else {
        this.$router.push({ name: 'companyAdd' })
      }
    },
    enterDoc() {
      this.$LogReport.sendCustomEvent('openplat_techfile_click')
      this.$router.push({ name: 'doc' })
    },
    handleCarousel(index) {
     this.currentIndex = index
    },
  },
}
</script>

<style lang="less" scoped>
.home {
  &-banner {
    height: 480px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.8s ease-in-out;
  }
  &-cover {
    width: 100%;
    max-width: 1440px;
    height: 480px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    transition: all 0.8s ease-in-out;
  }
  &-handle {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    &-circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #ccc;
      margin: 0 5px;
      display: inline-block;
      opacity: 0.5;
      transition: all 0.8s ease-in-out;
      cursor: pointer;
    }
    &-active {
      opacity: 1;
    }
  }
  &-text {
    position: absolute;
    width: 540px;
    top: 50%;
    transform: translateY(-50%);
    left: 40px;

    .home-text-logo {
      transition: all 0.8s ease-in-out;
      height: 98px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
    &-btn {
      margin-top: 20px;
      display: flex;
      align-items: center;
      button {
        background: #00A1D6;
        border: 1px solid rgba(0,0,0,0.50);
        border-radius: 2px;
        font-family: PingFangSC-Semibold, sans-serif;
        font-size: 22px;
        color: #ffffff;
        text-align: center;
        width: 164px;
        height: 56px;
        box-sizing: border-box;
        outline: none;
        cursor: pointer;
        font-weight: 600;
      }

      button + button {
        margin-left: 20px;
      }

      button.home-text-btn-2 {
        background: #FFFFFF;
        color: #23ADE5;
      }
    }
  }
}
</style>
